(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3231],{

/***/ 6551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CategoriesAside; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/store/categories.js
var store_categories = __webpack_require__(9266);
// EXTERNAL MODULE: ./src/utils/products.js
var products = __webpack_require__(1003);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/store/products.js
var store_products = __webpack_require__(58345);
// EXTERNAL MODULE: ./src/components/CategoriesAside/CategoriesAccordion.module.scss
var CategoriesAccordion_module = __webpack_require__(18883);
var CategoriesAccordion_module_default = /*#__PURE__*/__webpack_require__.n(CategoriesAccordion_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/OffersAside/OffersAside.jsx










function OffersAside(_ref) {
  var _cn, _cn2;

  var name = _ref.name,
      slugName = _ref.slugName,
      _ref$isSuper = _ref.isSuper,
      isSuper = _ref$isSuper === void 0 ? false : _ref$isSuper;

  var _useState = (0,react.useState)(false),
      isActive = _useState[0],
      setIsActive = _useState[1];

  var router = (0,next_router.useRouter)();
  var slug = router.query.slug;

  function onClickLink() {
    store_products/* RenderedProducts.update */.vX.update({});
  }

  (0,react.useEffect)(function () {
    if (slug && slug[0] === 'offers' || router.route.includes('/offers') && !isSuper) {
      setIsActive(true);
      return;
    }

    if (slug && slug[0] === 'smart' || router.route.includes('/smart') && isSuper) {
      setIsActive(true);
      return;
    }

    setIsActive(false);
  }, [slug]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()((_cn = {}, (0,defineProperty/* default */.Z)(_cn, (CategoriesAccordion_module_default()).containerSelected, isActive), (0,defineProperty/* default */.Z)(_cn, (CategoriesAccordion_module_default()).container, !isActive), _cn)),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/".concat(slugName),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          className: classnames_default()((_cn2 = {}, (0,defineProperty/* default */.Z)(_cn2, (CategoriesAccordion_module_default()).categoriesSelected, isActive), (0,defineProperty/* default */.Z)(_cn2, (CategoriesAccordion_module_default()).categories, !isActive), _cn2)),
          onClick: onClickLink,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: classnames_default()((CategoriesAccordion_module_default())[slugName], (0,defineProperty/* default */.Z)({}, (CategoriesAccordion_module_default()).isActiveCategory, isActive))
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: name
          })]
        })
      })
    })
  });
}

/* harmony default export */ var OffersAside_OffersAside = (OffersAside);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./src/constants/routes.js
var routes = __webpack_require__(98924);
;// CONCATENATED MODULE: ./src/components/CategoriesAside/CategoriesAccordion.jsx












function CategoriesAccordion(_ref) {
  var _cn, _cn2;

  var categoryName = _ref.categoryName,
      categorySlug = _ref.categorySlug,
      subCategories = _ref.subCategories,
      active = _ref.active,
      slug = _ref.slug;

  var _useState = (0,react.useState)(false),
      isProductDetails = _useState[0],
      setIsProductDetails = _useState[1];

  function onClickLink() {
    store_products/* RenderedProducts.update */.vX.update({});
  }

  (0,react.useEffect)(function () {
    var _isProductDetailsPage = (0,products/* isProductDetailsPage */.wh)(slug);

    setIsProductDetails(_isProductDetailsPage);
  }, [slug]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: classnames_default()((_cn = {}, (0,defineProperty/* default */.Z)(_cn, (CategoriesAccordion_module_default()).containerSelected, active), (0,defineProperty/* default */.Z)(_cn, (CategoriesAccordion_module_default()).container, !active), _cn)),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "".concat(routes/* CATEGORIES */.aA, "/").concat(categorySlug),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
          className: classnames_default()((_cn2 = {}, (0,defineProperty/* default */.Z)(_cn2, (CategoriesAccordion_module_default()).categoriesSelected, active), (0,defineProperty/* default */.Z)(_cn2, (CategoriesAccordion_module_default()).categories, !active), (0,defineProperty/* default */.Z)(_cn2, (CategoriesAccordion_module_default()).disableEvents, active && !isProductDetails), _cn2)),
          onClick: onClickLink,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: classnames_default()((CategoriesAccordion_module_default())[categorySlug], (0,defineProperty/* default */.Z)({}, (CategoriesAccordion_module_default()).isActiveCategory, active))
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: (CategoriesAccordion_module_default()).innerContent,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              children: categoryName
            }), !active ? /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* MdKeyboardArrowRight */.AeI, {
              className: (CategoriesAccordion_module_default()).arrow
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* MdKeyboardArrowDown */.Ix0, {
              className: (CategoriesAccordion_module_default()).arrowActive
            })]
          })]
        })
      })
    }), active && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CategoriesAccordion_module_default()).subCategoriesContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "".concat(routes/* CATEGORIES */.aA, "/").concat(categorySlug),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          className: (CategoriesAccordion_module_default()).subCategories,
          onClick: onClickLink,
          children: "\u038C\u03BB\u03B1"
        })
      })
    }), subCategories && active && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: subCategories.map(function (subC) {
        var _cn4, _cn5;

        var selected = slug[1] && slug[1] === subC.slugAscii;
        return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: classnames_default()((_cn4 = {}, (0,defineProperty/* default */.Z)(_cn4, (CategoriesAccordion_module_default()).subCategoriesContainerSelected, selected), (0,defineProperty/* default */.Z)(_cn4, (CategoriesAccordion_module_default()).subCategoriesContainer, !selected), _cn4)),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "".concat(routes/* CATEGORIES */.aA, "/").concat(categorySlug, "/").concat(subC.slugAscii),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: classnames_default()((_cn5 = {}, (0,defineProperty/* default */.Z)(_cn5, (CategoriesAccordion_module_default()).subCategoriesSelected, selected), (0,defineProperty/* default */.Z)(_cn5, (CategoriesAccordion_module_default()).subCategories, !selected), (0,defineProperty/* default */.Z)(_cn5, (CategoriesAccordion_module_default()).disableEvents, selected && !isProductDetails), _cn5)),
              children: subC.name
            })
          })
        }, subC._id);
      })
    })]
  });
}
// EXTERNAL MODULE: ./src/components/CategoriesAside/CategoriesAside.module.scss
var CategoriesAside_module = __webpack_require__(90585);
var CategoriesAside_module_default = /*#__PURE__*/__webpack_require__.n(CategoriesAside_module);
;// CONCATENATED MODULE: ./src/components/CategoriesAside/CategoriesAside.jsx











function CategoriesAside(_ref) {
  var categoriesFromFile = _ref.categoriesFromFile,
      slug = _ref.slug,
      category = _ref.category;

  var _useState = (0,react.useState)([]),
      categories = _useState[0],
      setCategories = _useState[1];

  var _isProductDetailsPage = (0,products/* isProductDetailsPage */.wh)(slug);

  (0,react.useEffect)(function () {
    var categories$ = store_categories/* default.subscribe */.Z.subscribe(setCategories);
    return function () {
      categories$.unsubscribe();
    };
  }, []);

  if (isEmpty_default()(categories)) {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("aside", {
      className: classnames_default()((CategoriesAside_module_default()).aside, (CategoriesAside_module_default()).parentIsSticky, (0,defineProperty/* default */.Z)({}, (CategoriesAside_module_default()).noOverflow, _isProductDetailsPage)),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OffersAside_OffersAside, {
        name: "\u03A0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2",
        slugName: "offers"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OffersAside_OffersAside, {
        name: "\u0388\u03BE\u03C5\u03C0\u03BD\u03B5\u03C2 \u03B1\u03B3\u03BF\u03C1\u03AD\u03C2",
        slugName: "smart",
        isSuper: true
      }), categoriesFromFile && categoriesFromFile.map(function (c) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(CategoriesAccordion, {
          categoryName: c.name,
          categorySlug: c.slugAscii,
          slug: slug,
          subCategories: c.subCategories,
          active: (category === null || category === void 0 ? void 0 : category.slugAscii) === (c === null || c === void 0 ? void 0 : c.slugAscii)
        }, c._id);
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("aside", {
    className: classnames_default()((CategoriesAside_module_default()).aside, (CategoriesAside_module_default()).parentIsSticky, (0,defineProperty/* default */.Z)({}, (CategoriesAside_module_default()).noOverflow, _isProductDetailsPage)),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OffersAside_OffersAside, {
      name: "\u03A0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2",
      slugName: "offers"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OffersAside_OffersAside, {
      name: "\u0388\u03BE\u03C5\u03C0\u03BD\u03B5\u03C2 \u03B1\u03B3\u03BF\u03C1\u03AD\u03C2",
      slugName: "smart"
    }), categories && categories.map(function (c) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CategoriesAccordion, {
        categoryName: c.name,
        categorySlug: c.slugAscii,
        slug: slug,
        subCategories: c.subCategories,
        active: (category === null || category === void 0 ? void 0 : category.slugAscii) === (c === null || c === void 0 ? void 0 : c.slugAscii)
      }, c._id);
    })]
  });
}

/***/ }),

/***/ 11848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CategoriesBanner; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constants/routes.js
var routes = __webpack_require__(98924);
// EXTERNAL MODULE: ./src/store/productsSort.js
var productsSort = __webpack_require__(43660);
// EXTERNAL MODULE: ./src/utils/analytics.js
var analytics = __webpack_require__(99700);
// EXTERNAL MODULE: ./src/utils/objectManipulation.js
var objectManipulation = __webpack_require__(18745);
// EXTERNAL MODULE: ./src/utils/bannerOptions.js
var bannerOptions = __webpack_require__(76962);
// EXTERNAL MODULE: ./src/components/SortingOptions/SortingOptions.module.scss
var SortingOptions_module = __webpack_require__(55746);
var SortingOptions_module_default = /*#__PURE__*/__webpack_require__.n(SortingOptions_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/SortingOptions/SortingOptions.jsx





function SortingOptions(_ref) {
  var showBySelection = _ref.showBySelection,
      onChange = _ref.onChange;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("select", {
    className: (SortingOptions_module_default()).select,
    value: showBySelection,
    onChange: onChange,
    children: [!router.asPath.includes('/search') && /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
      value: bannerOptions/* default.catalog */.Z.catalog,
      children: "\u03A0\u03C1\u03BF\u03B5\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE"
    }), router.asPath.includes('/search') && /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
      value: bannerOptions/* default.catalog */.Z.catalog,
      children: "\u03A3\u03C5\u03BD\u03AC\u03C6\u03B5\u03B9\u03B1"
    }), !router.asPath.includes('/offer') && !router.asPath.includes('/smart') && /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
      value: bannerOptions/* default.offer */.Z.offer,
      children: "\u03A0\u03C1\u03BF\u03C3\u03C6\u03BF\u03C1\u03AD\u03C2"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
      value: bannerOptions/* default.alphabetical */.Z.alphabetical,
      children: "\u0391\u03BB\u03C6\u03B1\u03B2\u03B7\u03C4\u03B9\u03BA\u03AC"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
      value: bannerOptions/* default.expensive */.Z.expensive,
      children: "\u0391\u03BA\u03C1\u03B9\u03B2\u03CC -> \u03A6\u03C4\u03B7\u03BD\u03CC"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
      value: bannerOptions/* default.cheap */.Z.cheap,
      children: "\u03A6\u03C4\u03B7\u03BD\u03CC -> \u0391\u03BA\u03C1\u03B9\u03B2\u03CC"
    }), !router.asPath.includes('/offer') && !router.asPath.includes('/smart') && /*#__PURE__*/(0,jsx_runtime.jsx)("option", {
      value: bannerOptions/* default.kiloPrice */.Z.kiloPrice,
      children: "\u03A4\u03B9\u03BC\u03AE \u03BA\u03B9\u03BB\u03BF\u03CD"
    })]
  });
}
// EXTERNAL MODULE: ./src/components/CategoriesBanner/CategoriesBanner.module.scss
var CategoriesBanner_module = __webpack_require__(49464);
var CategoriesBanner_module_default = /*#__PURE__*/__webpack_require__.n(CategoriesBanner_module);
;// CONCATENATED MODULE: ./src/components/CategoriesBanner/CategoriesBanner.jsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }















function CategoriesBanner(_ref) {
  var onChangeOrderBy = _ref.onChangeOrderBy,
      showBySelection = _ref.showBySelection,
      numOfProducts = _ref.numOfProducts,
      categoryName = _ref.categoryName,
      slug = _ref.slug,
      subCategoryName = _ref.subCategoryName,
      isSearch = _ref.isSearch,
      term = _ref.term,
      _ref$hideOrderBy = _ref.hideOrderBy,
      hideOrderBy = _ref$hideOrderBy === void 0 ? false : _ref$hideOrderBy,
      _ref$onlyProducts = _ref.onlyProducts,
      onlyProducts = _ref$onlyProducts === void 0 ? '' : _ref$onlyProducts;
  var router = (0,next_router.useRouter)();

  function onChangeSorting(e) {
    var _e$target, _router$query, _router$query2;

    onChangeOrderBy(e);
    (0,analytics/* changeSorting */.gB)(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);

    var query = _objectSpread(_objectSpread(_objectSpread({}, (0,objectManipulation/* getValidObject */.t9)('filter', router === null || router === void 0 ? void 0 : (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.filter)), (0,objectManipulation/* getValidObject */.t9)('brand', router === null || router === void 0 ? void 0 : (_router$query2 = router.query) === null || _router$query2 === void 0 ? void 0 : _router$query2.brand)), (0,objectManipulation/* getValidObject */.t9)('sortBy', e.target.value));

    router.push({
      pathname: router.asPath.split('?')[0],
      query: query
    }, undefined, {
      shallow: true
    });
  }

  (0,react.useEffect)(function () {
    var _router$query3;

    var sortBy = (0,objectManipulation/* getValidObject */.t9)('sortBy', router === null || router === void 0 ? void 0 : (_router$query3 = router.query) === null || _router$query3 === void 0 ? void 0 : _router$query3.sortBy);

    if (!isEmpty_default()(sortBy)) {
      productsSort/* default.update */.Z.update(sortBy.sortBy);
    }
  }, [slug]);
  var firstStep = slug && slug[0] !== 'offers' ? slug[0] !== 'smart' ? "".concat(routes/* CATEGORIES */.aA, "/").concat(slug[0]) : '/smart' : '/offers';
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (CategoriesBanner_module_default()).bannerFooter,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CategoriesBanner_module_default()).bannerText,
      children: [!isSearch && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: (CategoriesBanner_module_default()).bannerLink,
            children: "\u0391\u03C1\u03C7\u03B9\u03BA\u03AE"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (CategoriesBanner_module_default()).text,
          children: " > "
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: firstStep,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            className: (CategoriesBanner_module_default()).bannerLink,
            children: categoryName
          })
        }), slug.length >= 2 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: (CategoriesBanner_module_default()).text,
            children: " > "
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "".concat(routes/* CATEGORIES */.aA, "/").concat(slug[0], "/").concat(slug[1]),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: (CategoriesBanner_module_default()).bannerLink,
              children: subCategoryName
            })
          })]
        })]
      }), isSearch && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: (CategoriesBanner_module_default()).bannerLink,
        children: "\u0391\u03C0\u03BF\u03C4\u03B5\u03BB\u03AD\u03C3\u03BC\u03B1\u03C4\u03B1 \u0391\u03BD\u03B1\u03B6\u03AE\u03C4\u03B7\u03C3\u03B7\u03C2 > ".concat(term)
      })]
    }), onlyProducts && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: (CategoriesBanner_module_default()).bannerText,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: classnames_default()((CategoriesBanner_module_default()).text, (CategoriesBanner_module_default()).hideOnSmallScreen),
        children: onlyProducts
      })
    }), !hideOrderBy && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (CategoriesBanner_module_default()).bannerText,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        className: classnames_default()((CategoriesBanner_module_default()).text, (CategoriesBanner_module_default()).hideOnSmallScreen),
        children: [slug && slug[0] !== 'offers' && slug[0] !== 'smart' && /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          children: [numOfProducts, " \u03A0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03B1, "]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: "\u03A4\u03B1\u03BE\u03B9\u03BD\u03CC\u03BC\u03B7\u03C3\u03B7: "
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SortingOptions, {
        showBySelection: showBySelection,
        onChange: onChangeSorting
      })]
    })]
  });
}

/***/ }),

/***/ 33919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CategoriesModal; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60155);
/* harmony import */ var _utils_modalStyle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13764);
/* harmony import */ var _CategoriesAside_CategoriesAside__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6551);
/* harmony import */ var _GenericModal_GenericModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49875);
/* harmony import */ var _CategoriesModal_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42338);
/* harmony import */ var _CategoriesModal_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_CategoriesModal_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function CategoriesModal(_ref) {
  var isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen,
      slug = _ref.slug,
      category = _ref.category;
  var modal = {
    isOpen: isOpen,
    closeModal: setIsOpen,
    headerClass: (_CategoriesModal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modalHeader),
    customStyles: {
      overlay: _objectSpread({}, _utils_modalStyle__WEBPACK_IMPORTED_MODULE_1__/* ["default"].overlay */ .Z.overlay),
      content: {
        width: '41.45rem'
      }
    },
    icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_6__/* .IoClose */ .bjh, {
      className: (_CategoriesModal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().closeModal)
    }),
    bodyOverwrite: 'fullBody',
    isFullscreen: true,
    animate: true,
    navigation: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("h3", {
      children: "\u039A\u03B1\u03C4\u03B7\u03B3\u03BF\u03C1\u03AF\u03B5\u03C2"
    }, 1)],
    view: 'Categories',
    body: {
      Categories: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_CategoriesAside_CategoriesAside__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        slug: slug,
        isSticky: true,
        category: category
      })
    }
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_GenericModal_GenericModal__WEBPACK_IMPORTED_MODULE_3__["default"], {
    modal: modal
  });
}

/***/ }),

/***/ 16723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CategoriesSelect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5434);
/* harmony import */ var _store_categories__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9266);
/* harmony import */ var _CategoriesModal_CategoriesModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33919);
/* harmony import */ var _FavoritesAside_FavoritesAside__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79255);
/* harmony import */ var _CategoriesSelect_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24209);
/* harmony import */ var _CategoriesSelect_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_CategoriesSelect_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);








function CategoriesSelect(_ref) {
  var slug = _ref.slug;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      showCategories = _useState[0],
      setShowCategories = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      categories = _useState2[0],
      setCategories = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]),
      category = _useState3[0],
      setCategory = _useState3[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var categories$ = _store_categories__WEBPACK_IMPORTED_MODULE_1__/* ["default"].subscribe */ .Z.subscribe(setCategories);
    return function () {
      categories$.unsubscribe();
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var currentCategory = categories.find(function (_category) {
      return _category.slugAscii === slug[0];
    });
    setCategory(currentCategory);
  }, [categories]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (showCategories) {
      setShowCategories(false);
    }
  }, [slug]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("section", {
    className: (_CategoriesSelect_module_scss__WEBPACK_IMPORTED_MODULE_5___default().showOnSmallScreen),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: (_CategoriesSelect_module_scss__WEBPACK_IMPORTED_MODULE_5___default().container),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("button", {
        type: "button",
        className: (_CategoriesSelect_module_scss__WEBPACK_IMPORTED_MODULE_5___default().categoriesBtn),
        onClick: function onClick() {
          return setShowCategories(!showCategories);
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
          children: "\u039A\u03B1\u03C4\u03B7\u03B3\u03BF\u03C1\u03AF\u03B5\u03C2 \u03C0\u03C1\u03BF\u03CA\u03CC\u03BD\u03C4\u03C9\u03BD"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_6__/* .MdKeyboardArrowDown */ .Ix0, {
          className: (_CategoriesSelect_module_scss__WEBPACK_IMPORTED_MODULE_5___default().arrowIcon),
          alt: "\u03AC\u03BD\u03BF\u03B9\u03B3\u03BC\u03B1 \u03BA\u03B1\u03C4\u03B7\u03B3\u03BF\u03C1\u03AF\u03C9\u03BD"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_FavoritesAside_FavoritesAside__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_CategoriesModal_CategoriesModal__WEBPACK_IMPORTED_MODULE_2__["default"], {
      isOpen: showCategories,
      setIsOpen: setShowCategories,
      slug: slug,
      category: category
    })]
  });
}

/***/ }),

/***/ 79255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FavoriteAside; }
/* harmony export */ });
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_icons_io__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51649);
/* harmony import */ var _FavoritesAside_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30236);
/* harmony import */ var _FavoritesAside_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_FavoritesAside_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





function FavoriteAside() {
  var tooltip = 'Δες τη λίστα με τα αγαπημένα σου και τις έξυπνες προτάσεις προϊόντων που ψωνίζεις συχνά, για ακόμα πιο εύκολες και γρήγορες αγορές!';
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
    href: "/favorites",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
      className: (_FavoritesAside_module_scss__WEBPACK_IMPORTED_MODULE_2___default().favoriteLink),
      title: tooltip,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (_FavoritesAside_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_io__WEBPACK_IMPORTED_MODULE_3__/* .IoMdHeart */ .$g3, {
          className: (_FavoritesAside_module_scss__WEBPACK_IMPORTED_MODULE_2___default().favoriteIcon)
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: "\u0391\u03B3\u03B1\u03C0\u03B7\u03BC\u03AD\u03BD\u03B1"
        })]
      })
    })
  });
}

/***/ }),

/***/ 49875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ GenericModal; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59499);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60155);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83253);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_modal__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49906);
/* harmony import */ var _GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







function GenericModal(_ref) {
  var modal = _ref.modal;
  var modalClasses = modal.isFullscreen ? {
    base: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().fullScreen), (_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().animatedModal), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, modal.contentClass, modal.contentClass)),
    afterOpen: (_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["animatedModal--after-open"]),
    beforeClose: (_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["animatedModal--before-close"])
  } : classnames__WEBPACK_IMPORTED_MODULE_0___default()((0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, modal.contentClass, modal.contentClass));
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)((react_modal__WEBPACK_IMPORTED_MODULE_1___default()), {
    isOpen: modal.isOpen,
    onAfterOpen: modal.afterOpenModal,
    onRequestClose: modal.closeModal,
    style: modal.customStyles,
    contentLabel: modal.label,
    portalClassName: (_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().modal),
    overlayClassName: classnames__WEBPACK_IMPORTED_MODULE_0___default()((0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, modal.overlayClass, modal.overlayClass))
    /* if you are using React 16, the close transition works only if
    you use the isOpen prop to toggle the visibility of the modal. */
    ,
    closeTimeoutMS: modal.isFullscreen ? 400 : 0,
    className: modalClasses,
    ariaHideApp: false,
    children: [modal.closeModal && modal.navigation.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().header), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, modal.headerClass, modal.headerClass)),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        children: modal.navigation.map(function (nav) {
          return nav;
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("button", {
        type: "button",
        className: (_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().close),
        onClick: function onClick() {
          return modal.closeModal();
        },
        children: modal.icon ? modal.icon : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_5__/* .IoClose */ .bjh, {
          className: (_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().closeSymbol)
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().body), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default())[modal.bodyOverwrite], modal.bodyOverwrite)),
      children: modal.body[modal.view]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: (_GenericModal_module_scss__WEBPACK_IMPORTED_MODULE_3___default().footer)
    })]
  });
}

/***/ }),

/***/ 43660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var rxjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20090);

var INITIAL_SUBJECT_VALUE = 'default';
var meta = {
  cached: false,
  fetched: false,
  updatedAt: new Date()
};
var SortBy = {
  subject: new rxjs__WEBPACK_IMPORTED_MODULE_0__/* .BehaviorSubject */ .X(INITIAL_SUBJECT_VALUE),
  update: function update(sortOption) {
    SortBy.subject.next(sortOption);
    Object.assign(meta, {
      fetched: true,
      updatedAt: new Date()
    });
  },
  delete: function _delete() {
    SortBy.update(INITIAL_SUBJECT_VALUE);
  },
  subscribe: function subscribe(setState) {
    return SortBy.subject.subscribe(setState);
  },
  getValue: function getValue() {
    return SortBy.subject.value;
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (SortBy);

/***/ }),

/***/ 18883:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"categoriesDefault":"CategoriesAccordion_categoriesDefault__o9bzZ","categoriesSelected":"CategoriesAccordion_categoriesSelected__VXuTG","categories":"CategoriesAccordion_categories__iN5hi","offers":"CategoriesAccordion_offers__NtlA6","smart":"CategoriesAccordion_smart__4gK1S","manabikh":"CategoriesAccordion_manabikh__5Tmgb","fresko-kreas":"CategoriesAccordion_fresko-kreas__I9UPh","allantika":"CategoriesAccordion_allantika__hu0UR","turokomika":"CategoriesAccordion_turokomika__T8cVK","galaktokomika":"CategoriesAccordion_galaktokomika__4O8bk","eidh-psugeiou":"CategoriesAccordion_eidh-psugeiou__exklj","katapsuxh":"CategoriesAccordion_katapsuxh__VpO6j","pantopwleio":"CategoriesAccordion_pantopwleio__CVAW3","kaba":"CategoriesAccordion_kaba__sQtv5","proswpikh-frontida":"CategoriesAccordion_proswpikh-frontida__Jta5p","brefika":"CategoriesAccordion_brefika__rsapi","kathariothta":"CategoriesAccordion_kathariothta__9aCJI","oikiakh-xrhsh":"CategoriesAccordion_oikiakh-xrhsh__m7ci2","pet-shop":"CategoriesAccordion_pet-shop__oG6iT","biologikaleitourgika":"CategoriesAccordion_biologikaleitourgika__gMZLm","hlektrikes-suskeues":"CategoriesAccordion_hlektrikes-suskeues__47XLC","isActiveCategory":"CategoriesAccordion_isActiveCategory___c_CA","containerDefault":"CategoriesAccordion_containerDefault__gQUg2","containerSelected":"CategoriesAccordion_containerSelected__43qhW","container":"CategoriesAccordion_container__TT67a","innerContent":"CategoriesAccordion_innerContent__sCHnO","accordionImg":"CategoriesAccordion_accordionImg__dyrzy","subCategoriesContainerDefault":"CategoriesAccordion_subCategoriesContainerDefault__FkFhY","subCategoriesContainerSelected":"CategoriesAccordion_subCategoriesContainerSelected__py0_4","subCategoriesContainer":"CategoriesAccordion_subCategoriesContainer__F1SEZ","subCategoriesDefault":"CategoriesAccordion_subCategoriesDefault__9a7gP","subCategoriesSelected":"CategoriesAccordion_subCategoriesSelected__ySJSV","subCategories":"CategoriesAccordion_subCategories__lcT4x","disableEvents":"CategoriesAccordion_disableEvents__jLGNB","arrow":"CategoriesAccordion_arrow__v4MW6","arrowActive":"CategoriesAccordion_arrowActive__P5oO_"};

/***/ }),

/***/ 90585:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"aside":"CategoriesAside_aside__Ni9hK","parentIsSticky":"CategoriesAside_parentIsSticky___NCFO","noOverflow":"CategoriesAside_noOverflow__f3FKX"};

/***/ }),

/***/ 49464:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"CategoriesBanner_footer__oB_5U","bannerExpressFooter":"CategoriesBanner_bannerExpressFooter__0owi9","bannerFooter":"CategoriesBanner_bannerFooter__42P9y","bannerText":"CategoriesBanner_bannerText__i6vwQ","bannerLink":"CategoriesBanner_bannerLink__j5Cgb","container":"CategoriesBanner_container__0JQ3s","bannerLarge":"CategoriesBanner_bannerLarge__E1G25","bannerExpressContainer":"CategoriesBanner_bannerExpressContainer__xYfxA","bannerContainer":"CategoriesBanner_bannerContainer__5zgyt","img":"CategoriesBanner_img__0tnKL","text":"CategoriesBanner_text__vS6DC","hideOnSmallScreen":"CategoriesBanner_hideOnSmallScreen__fS5vt"};

/***/ }),

/***/ 42338:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"CategoriesModal_modalHeader__pLRwY","closeModal":"CategoriesModal_closeModal__aGrCr"};

/***/ }),

/***/ 24209:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"showOnSmallScreen":"CategoriesSelect_showOnSmallScreen__TO3TL","container":"CategoriesSelect_container__PzS_I","categoriesBtn":"CategoriesSelect_categoriesBtn__kbVYf","arrowIcon":"CategoriesSelect_arrowIcon__0FRzD"};

/***/ }),

/***/ 30236:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"FavoritesAside_container__GZNEi","favoriteLink":"FavoritesAside_favoriteLink__6dCNY","favoriteIcon":"FavoritesAside_favoriteIcon___oEg7"};

/***/ }),

/***/ 55746:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"select":"SortingOptions_select__rQogY"};

/***/ })

}]);